module.exports = __webpack_public_path__ + "img/monitor.a7c1d5a2.svg";